import styled from '@emotion/styled';
import { colors } from '../../styles/variables/colors';

export const StyledHero = styled.div`
  width: 100%;
  padding: 60px 0px;
  background-color: ${colors.lightGrey};
`;
